import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { formsService } from '../api/forms.service';
import { FORM_KEYS } from './queryKeys';

/** Response analytics: totals, per-field breakdown, abandonment, and respondents. */
export function useFormAnalytics(formId: string) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const { data, isLoading, isError } = useQuery({
    queryKey: FORM_KEYS.analytics(orgId ?? '', formId),
    queryFn: ({ signal }) => formsService.getAnalytics(formId, signal),
    staleTime: 30_000,
    enabled: !!orgId && !!formId,
  });

  return {
    analytics: data?.data,
    isLoading,
    isError,
  };
}
